import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { DealFilterEffects } from './deal-filter.effects';
import { initialState, reducer } from './deal-filter.reducer';
import { DealFilterState } from './deal-filter.state';
import { createWorkspaceScopedSyncReducer } from '../local-storage-sync';

const syncLocalStorageMetaReducer = createWorkspaceScopedSyncReducer<DealFilterState>(
  {
    keys: ['modeLookup', 'isBasketScope'],
    rehydrate: true,
    storage: localStorage,
  },
  'deal-filter-',
);

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('dealFilter', reducer, {
      initialState,
      metaReducers: [syncLocalStorageMetaReducer],
    }),
    EffectsModule.forFeature([DealFilterEffects]),
  ],
  providers: [DealFilterEffects],
})
export class DealFilterStoreModule {}
